import { useMemo } from 'react';

import cn from 'classnames';

import styles from './BackgroundImageGradient.module.scss';

type Props = {
  className?: string;
  color: string;
  endAlpha: number;
  gradientDirection: 'bottom' | 'top';
  middleAlpha: number;
  src?: string;
  startAlpha: number;
};

const BackgroundImageGradient = ({
  className,
  color,
  endAlpha,
  gradientDirection,
  middleAlpha,
  src,
  startAlpha,
}: Props) => {
  const backgroundImage = useMemo(() => {
    if (!src) {
      return undefined;
    }
    const red = parseInt(color.slice(1, 3), 16);
    const green = parseInt(color.slice(3, 5), 16);
    const blue = parseInt(color.slice(5, 7), 16);
    const startColor = `rgba(${red}, ${green}, ${blue}, ${startAlpha})`;
    const middleColor = `rgba(${red}, ${green}, ${blue}, ${middleAlpha})`;
    const endColor = `rgba(${red}, ${green}, ${blue}, ${endAlpha})`;
    return `linear-gradient(to ${gradientDirection}, ${startColor} 0%, ${middleColor} 50%, ${endColor} 100%), url('${src}')`;
  }, [color, startAlpha, middleAlpha, endAlpha, gradientDirection, src]);

  const classNames = cn(className, styles[gradientDirection], styles.imageContent);

  return (
    <div className={styles.imageContainer}>
      <div className={classNames}>
        <div className={styles.imageGradient} style={{ backgroundImage }} />
      </div>
    </div>
  );
};

export default BackgroundImageGradient;
